import { AdminEntity } from '../../models/adminEntity';

// Services and functions are administered the same way (L2-ASF): a single
// screen parameterised by `kind`, and these labels are the only thing that changes.

export type AdminEntityKind = 'service' | 'function';

export type Labels = {
  path: string;
  title: string;
  /** "le service" / "la fonction", for the sentences. */
  one: string;
  addPlaceholder: string;
  /** Key of the collection in the response: `services` / `functions`. */
  collection: string;
  /** Cache key that the other screens use for this list. */
  cacheKeys: string[];
};

export const LABELS: Record<AdminEntityKind, Labels> = {
  service: {
    path: 'services',
    title: 'Services',
    one: 'le service',
    addPlaceholder: 'Ajouter un service',
    collection: 'services',
    // `GET_SERVICES` is used by the earlier pages (they store the Response);
    // `HOME_SERVICES` by the Home, the wizard and the user form.
    cacheKeys: ['GET_SERVICES', 'HOME_SERVICES'],
  },
  function: {
    path: 'functions',
    title: 'Fonctions',
    one: 'la fonction',
    addPlaceholder: 'Ajouter une fonction',
    collection: 'functions',
    cacheKeys: ['GET_FUNCTIONS', 'USER_FORM_FUNCTIONS'],
  },
};

export const ENTITIES_QUERY_KEY = 'ADMIN_ENTITIES';

export type EntityAction = 'rename' | 'toggle' | 'history' | 'remove';

export type EntityRow = AdminEntity;
